import { render, staticRenderFns } from "./RecoverPassword1.vue?vue&type=template&id=b4961c62&"
import script from "./RecoverPassword1.vue?vue&type=script&lang=js&"
export * from "./RecoverPassword1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports